import { Box, Stack } from '@mui/material'
import { useState } from 'react'
import { IconButton } from 'utoniq-ui'

import { ItemThumbnailType } from '@/clients/utoniq-core/schema'
import { ItemReversibleThumbnail, ItemStatusCell } from '@/components/organisms'
import {
  ItemResourcePlayerCell,
  usePrivacyScreen,
} from '@/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailVideoView'
import { ThumbnailActionAreaCell } from '@/components/pages/OwnedItemDetail/template/components/ThumbnailActionArea'
import { Cell } from '@/core/architecture'

import { State } from './'
import { ConsoleItemDescription } from './ConsoleItemDescription'

export type ConsoleItemDetailVideoProps = {
  loading: boolean
  item: State['item']
  isFlipped: boolean
  onReverseThumbnail: () => void
  onOpenFullScreen: () => void
  onOpenMultipleImage: () => void
}

export const ConsoleItemDetailVideo: Cell<ConsoleItemDetailVideoProps> = ({
  loading,
  item,
  isFlipped,
  onReverseThumbnail,
  onOpenFullScreen,
  onOpenMultipleImage,
}) => {
  usePrivacyScreen()
  const [displayResource, setDisplayResource] = useState(false)
  const videoResource = item?.resource

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <ThumbnailActionAreaCell
          onOpenFullScreen={onOpenFullScreen}
          onOpenMultipleImage={onOpenMultipleImage}
          numberImage={item?.images?.length ?? 0}
        />
        <ItemReversibleThumbnail
          loading={loading}
          flipProps={{
            isFlipped,
          }}
          btnPlay={{
            type: 'back',
            onClick: () => setDisplayResource(prevState => !prevState),
          }}
          imageAreaProps={{
            thumbnail: item?.thumbnail,
            size:
              item?.thumbnailType === ItemThumbnailType.Square
                ? 'x-large-square'
                : 'x-large',
            onClick: onReverseThumbnail,
          }}
        />
      </Box>
      {item && !loading && (
        <Stack sx={{ pt: 3 }}>
          <ItemStatusCell
            salesCondition={item.salesCondition}
            isPublished={item.isPublished}
            isDrm={item.isDrm}
            isPremium={item.isPremium}
          />
        </Stack>
      )}
      <ConsoleItemDescription item={item} loading={loading} />

      <Box sx={{ mt: 6, mb: 2 }}>
        {videoResource && !isFlipped ? (
          <IconButton.Video
            size="small"
            onClick={onReverseThumbnail}
            bgcolor="primary.main"
            color="white"
          />
        ) : (
          <IconButton.Rotate
            size="small"
            onClick={onReverseThumbnail}
            bgcolor="primary.main"
            color="white"
          />
        )}
      </Box>
      {item && (
        <ItemResourcePlayerCell
          open={displayResource}
          onClose={() => setDisplayResource(prevState => !prevState)}
          item={item}
        />
      )}
    </>
  )
}
